<template lang="pug">
  main
    NavBarAccesos
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        h3.title.is-3 Firma del operador
        br
        .columns.is-mobile
          .column.is-12-mobile.is-offset-3-tablet.is-6-tablet
            //- iframe(width='560' height='500' :src="ruta" frameborder='0' allowfullscreen='')
            Signature(@saveFile="checkFile")
</template>

<script>
  import NavBarAccesos from '@/components/sca_Componentes/acceso/layout/NavBarAccesos.vue'
  import Loader from '@/components/shared/Loader.vue'
  import Signature from './Signature.vue'
  import autotanquesServicesIRGE from '@/services/irge/autotanquesIRGE.js'

  import { mapState } from 'vuex'
  export default {
    name: 'FirmaPuntos',
    components: { NavBarAccesos, Loader, Signature },
    data() {
      return {
        w: 320,
        h: 220,
        idPuntos: '',
        isLoading: true,
        ruta: '',
        firma: '',
        nombreFile: '',
      }
    },
    methods: {
      iniciarComponente () {
        setTimeout(() => {
          this.isLoading = false
        }, 340)
      },
      guardarFirma() {
        this.$emit('acceso:guardar', true)
      },
      onLoad (event) {
        console.log(event)
      },
      onDocumentLoad (event) {
        console.log(event)
      },
      checkFile (file) {
        console.log(file)
        this.firma = file
        this.nombreFile = `firma_${this.idPuntos}`

        if (this.firma !== 'NoData') {
          autotanquesServicesIRGE.firmarPuntos(this.accesoFirma, this.firma, this.nombreFile)
            .then( data => {
              console.log(data)
              if (data.success) {
                let toast = this.$toasted.show(`La Revisión de 23 puntos ha sido firmada.`, { 
                  theme: "toasted-primary", 
                  position: "bottom-right", 
                  duration : 3000,
                  iconPack: 'fontawesome',
                  icon: 'check',
                  action : {
                    text : 'Ok',
                    onClick : (e, toastObject) => {
                      toastObject.goAway(0)
                    }
                  },
                })
                this.backAccesos()
              } else {
                let toast = this.$toasted.show(`Erro: ${this.data.respuesta} ha sido firmada.`, { 
                  theme: "toasted-primary", 
                  position: "bottom-right", 
                  duration : 3000,
                  iconPack: 'fontawesome',
                  icon: 'ban',
                  action : {
                    text : 'Ok',
                    onClick : (e, toastObject) => {
                      toastObject.goAway(0)
                    }
                  },
                })
              }
            })
            .catch( e => console.log(e))
        } else {
          console.log('No Guardar la Firma')
          let toast = this.$toasted.show('Error: No se ha firmado aún la requisición.', { 
            theme: "toasted-primary", 
            position: "bottom-right", 
            duration : 3000,
            iconPack: 'fontawesome',
            icon: 'ban',
            action : {
              text : 'Ok',
              onClick : (e, toastObject) => {
                toastObject.goAway(0)
              }
            },
          })
        }
      },
      backAccesos () {
        this.$router.push('/IRGE/Accesos')
      }
    },
    created () {
      var currentUrl = window.location.hostname
      console.log(currentUrl)
      this.iniciarComponente()
      this.idPuntos = this.accesoFirma
      this.ruta = `https://${currentUrl}/firmaIRGE/index.php?id=${this.idPuntos}`
      this.$store.commit('firmando', true)
    },
    computed: {
      ...mapState(['accesoFirma', 'userLogin'])
    }
  }
</script>


<style scoped>
  iframe {
    height: 300px !important;
    overflow-y: hidden !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/sca_Componentes/acceso/FirmaPuntos.vue